<template>
  <div class="app">
    <AppHeader fixed>
      <SidebarToggler class="d-lg-none" display="md" mobile />
      <b-link class="navbar-brand" to="#">
        <!-- <img class="navbar-brand-full" src="img/brand/logo.svg" width="89" height="25" alt="Tiara Buana Mandiri"> -->
        <img class="navbar-brand-full" src="img/logo.png" width="50" height="50" alt="Tiara Buana Mandiri">
        <!-- <img class="navbar-brand-minimized" src="img/brand/sygnet.svg" width="30" height="30" alt="Tiara Buana Mandiri"> -->
        <img class="navbar-brand-minimized" src="img/logo.png" width="50" height="50" alt="Tiara Buana Mandiri"></img>
      </b-link>
      <SidebarToggler class="d-md-down-none" display="lg" :defaultOpen=true />
      <!-- <b-navbar-nav class="d-md-down-none">
        <b-nav-item class="px-3" to="/dashboard">Dashboard</b-nav-item>
        <b-nav-item class="px-3" to="/users" exact>Users</b-nav-item>
        <b-nav-item class="px-3">Settings</b-nav-item>
      </b-navbar-nav> -->
      <b-navbar-nav class="ml-auto">
        <!-- <b-nav-item class="d-md-down-none">
          <i class="icon-bell"></i>
          <b-badge pill variant="danger">5</b-badge>
        </b-nav-item>
        <b-nav-item class="d-md-down-none">
          <i class="icon-list"></i>
        </b-nav-item>
        <b-nav-item class="d-md-down-none">
          <i class="icon-location-pin"></i>
        </b-nav-item> -->
        <!-- <DefaultHeaderDropdownAccnt/> -->
        <DefaultHeaderDropdownMenu/>
      </b-navbar-nav>
      <!-- <AsideToggler class="d-none d-lg-block" /> -->
      <!--<AsideToggler class="d-lg-none" mobile />-->
    </AppHeader>
    <div class="app-body">
      <AppSidebar fixed>
        <SidebarHeader/>
        <SidebarForm/>
        <SidebarNav :navItems="nav"></SidebarNav>
        <SidebarFooter/>
        <SidebarMinimizer/>
      </AppSidebar>
      <main class="main">
        <Breadcrumb :list="list"/>
        <div class="container-fluid">
          <router-view></router-view>
        </div>
      </main>
      <AppAside fixed>
        <!--aside-->
        <DefaultAside/>
      </AppAside>
    </div>
    <TheFooter>
      <!--footer-->
      <!-- <div>
      Copyright
      <span class="ml-1">&copy; 2019 Tiara Buana Mandiri.</span>
      </div>
      <div class="ml-auto">
        <span class="mr-1">Powered by </span> -->
        <!-- <a :href="powered_url">{{ powered_by }}</a> -->
        <!-- <a href="https://monstercode.net/">MonsterCode</a>
      </div> -->

      <!-- <b-container>
      <b-row align-h="center" class="p-12" style="font-size:10pt">
        <b-col cols="12" class="text-center">Copyright
        <span>&copy; 2019 Tiara Buana Mandiri</span></b-col>
        <b-col cols="12" class="text-center"><span class="">Powered by </span>
        <a href="https://monstercode.net/">MonsterCode</a></b-col>
      </b-row>
      </b-container> -->

      <b-container>
      <b-row align-h="center" class="p-12" style="font-size:10pt">
        <b-col cols="12" class="text-center">Copyright
        <span>&copy; 2019 Tiara Buana Mandiri</span></b-col>
        <b-col cols="12" class="text-center"><span class="">Powered by </span>
        <a :href="powered_url">{{ powered_by }}</a></b-col>
      </b-row>
      </b-container>

      <!-- <b-row>
    <b-col md="4">  Copyright
      <span class="ml-1">&copy; 2019 Tiara Buana Mandiri.</span></b-col>
    <b-col md="4" offset-md="4">Powered by <a href="https://monstercode.net/">MonsterCode</a></b-col>
  </b-row> -->



    </TheFooter>
  </div>
</template>

<script>
import nav from '@/_nav'
import { Header as AppHeader, SidebarToggler, Sidebar as AppSidebar, SidebarFooter, SidebarForm, SidebarHeader, SidebarMinimizer, SidebarNav, Aside as AppAside, AsideToggler, Footer as TheFooter, Breadcrumb } from '@coreui/vue'
import DefaultAside from './DefaultAside'
import DefaultHeaderDropdownMenu from './DefaultHeaderDropdownMenu'
//import DefaultHeaderDropdownAccnt from './DefaultHeaderDropdownAccnt'

export default {
  name: 'DefaultContainer',
  components: {
    AsideToggler,
    AppHeader,
    AppSidebar,
    AppAside,
    TheFooter,
    Breadcrumb,
    DefaultAside,
    DefaultHeaderDropdownMenu,
    //DefaultHeaderDropdownAccnt,
    SidebarForm,
    SidebarFooter,
    SidebarToggler,
    SidebarHeader,
    SidebarNav,
    SidebarMinimizer
  },
  data () {
    return {
      nav: nav.items,
      powered_by: process.env.POWERED_BY,
      powered_url: process.env.POWERED_URL
    }
  },
  computed: {
    name () {
      return this.$route.name
    },
    list () {
      return this.$route.matched.filter((route) => route.name || route.meta.label )
      // return this.$route.matched.filter((route) => (route.name || route.meta.label ).replace(/(\B[A-Z])/g, ' $1'))
    }
  }
}
</script>
